export default __webpack_public_path__ + "static/gptw-412b764626f08409e48dc6875f6da6fd.png";